import { render, staticRenderFns } from "./cancel-debit-card.component.vue?vue&type=template&id=476fe343&"
import script from "./cancel-debit-card.component.vue?vue&type=script&lang=ts&"
export * from "./cancel-debit-card.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports